module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("1. Introduction: On the Possibility and Conditions of a Constructive Christian Eschatology")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_c('strong', [_vm._v("The (Omni)Presence of Eschatology")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-t0",
    attrs: {
      "id": "sec2-1"
    }
  }, [_c('em', [_vm._v("The Visions of “End” in Culture and Society")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Unlike those of ancient times, contemporary cultures do not typically entertain the “myth of the eternal return,”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(" yet all living religions have a vision of the future and “end.” Hence we can speak of “eschatology” as a pan-religious idea. Eschatology, however, is not limited exclusively to the religious sphere. Just think of the growing concern, at times anxiety, in secular culture over the impending “end”—either of our planet or of human life."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" In contemporary sciences we have lately heard expressions such as “physical eschatology,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft3",
      "id": "fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" which investigates the future of the cosmos and life, whether in the near or far future; similarly, questions are being raised among scientists about “evolutionary eschatology,” that is, whether evolutionary process is to be considered progressive and if it ever culminates in a final goal."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft4",
      "id": "fn4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Indeed, even more widely, it seems obvious that “[e]very culture has an eschatology; it is part of our inescapable human attempt to make sense of the world.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" Although these secular visions are not distinctively religious, they tend to feature structural similarities with religions, as is evident in the "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Marxist tripartite outline of the world’s history: “A primal state of innocence, followed by a period of social tension, which is, in turn, supplanted by a new era of harmony, the communist society of the future.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(" Interestingly, it has also been argued recently that Friedrich Nietzsche, the most unlikely supporter of eschatology in either secular or religious forms, might have subscribed to a form of it. Could it be that this atheist’s vision of the rescue of “the use and abuse of history”—or as he also put it, the “disease of history”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v("—may be a concealed form of a “secularized Joachimite eschatology”?"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft8",
      "id": "fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" What if Joachim’s three ages—that of the Father, Son, and Spirit—are paralleled by Nietzsche’s scheme of history in three stages: premoral, moral, and ultramoral ages?"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft9",
      "id": "fn9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some kind of eschatological outlook can even be found in most recent predictions of the future of human civilization in sociopolitical thought. How else to think of the (in) famous proposal of Francis Fukuyama at the time of the collapse of Soviet Communism, ominously titled "), _c('em', [_vm._v("The End of History and the Last Man")]), _vm._v("? With a neoconservative confidence in the final victory of free-market capitalism and its version of democracy over other political ideologies, Fukuyama took it as the most developed and final stage of evolution, finally leading into peace as democracy’s supremacy is discerned by all."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" Not surprisingly, this “right-wing” vision of the inevitable progress of history toward freedom was harshly contested by the ideological left. In the neo-Marxist manifesto of Michael Hardt and Antonio Negri, "), _c('em', [_vm._v("Empire")]), _vm._v(", freedom is defeated by the empire, which replaces nation-states and even national conflicts with a new transnational global order, indeed an absolute and violent one. The new combined world rulers are international agencies and organizations from the UN to the World Bank and the alliance of rich nations, along with the “superpower” (USA). The sequel by the same authors, written after 9/11, titled "), _c('em', [_vm._v("Multitude: War and Democracy in the Age of Empire")]), _vm._v(" (2004), further diagnoses reasons for the failure of the dream of progress."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft11",
      "id": "fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" In sum: whatever one thinks of these various scenarios for the future, it appears that “eschatology” dies hard even in the secular realm.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('em', [_vm._v("The Eclipse of Eschatology in Christian Tradition")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("In distinctively Christian forms of eschatology, marked shifts have taken place in history. For the earliest followers of Christ, the intense expectation of the imminent return of their Lord was just that—"), _c('em', [_vm._v("intense")]), _vm._v("; the (early) patristic church continued this focus."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(" Apocalyptic enthusiasm flourished in diverse forms. Even such intellectually oriented writers as the apologists of the second century employed urgent eschatological warnings and visions in their defense of the faith before the unbelieving world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" Although the eschatological hope waned some after the establishment of Christendom and its amillennialism, in no way did it die out. Indeed, more often than not, particularly in the Middle Ages and all way to the Reformation era, eschatological-apocalyptic imagination fueled spirituality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By the time of modernity, eschatological “hope” had lost its meaning among the intelligentsia."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft14",
      "id": "fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" Kant’s focus on religion’s effect on morality undoubtedly helped the nineteenth-century liberal Protestants and others to reduce faith to the subjective and moral dimensions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft15",
      "id": "fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" And even the “rediscovery” of eschatology at the turn of the twentieth century in liberal New Testament scholarship (Johannes Weiss, Albert Schweitzer, and others) hardly signaled a robust interest in the "), _c('em', [_vm._v("theological")]), _vm._v(" significance of the end times. Not only did these scholars not believe the content of the New Testament claims regarding eschatology, but they were more keen on apocalypticism and, most ironically, its naive but totally mistaken application by Jesus and the disciples!"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft16",
      "id": "fn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Simultaneously, though for different reasons, dismissal—or even an aggressive disavowal—of eschatological hope was funded by other leading philosophical and cultural figures. As is well known, L. Feuerbach took the human desire for life after death as a form of egotism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft17",
      "id": "fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" He completely misunderstood the essence of Christian eschatological hope, as he took it as the "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("denial of true human existence, particularly physicality."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(" The Freudian rejection of (religious) imagination of the afterlife merely as a (neurotic, or at least immature) form of an illusion attracted many followers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft19",
      "id": "fn19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Freudian interpretation sticks well with the contemporary naturalist worldview. The famed early twentieth-century British atheist philosopher Bertrand Russell opined that “[a]ll the evidence goes to show that what we regard as our mental life is bound up with brain structure and organized bodily energy. Therefore it is rational to suppose that mental life ceases when body ceases.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft20",
      "id": "fn20"
    }
  }, [_vm._v("20")])]), _vm._v(" Philosophers such as Anthony Flew continued their persistent critique, targeting any belief in an afterlife and personal survival after death. He found logically and rationally failing the attempts by ancient philosophers, Christians and other believers, as well as those who consider near-death experiences, to establish the possibility of personal survival."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft21",
      "id": "fn21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No wonder that in much of post-Enlightenment theology any talk in the line of tradition about the “end” lacked content and became marginalized. The work begun by A. Schweitzer and other liberals was picked up in the latter part of the twentieth century by the (in) famous American Jesus Seminar. The late Marcus J. Borg advocated a totally noneschatological interpretation of Jesus and took the kingdom of God as merely a this-worldly entity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft22",
      "id": "fn22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some leading systematic theologians similarly dismissed or radically revised eschatology. There is almost no mention of eschatological themes in Gordon Kaufman’s "), _c('em', [_vm._v("In Face of Mystery: A Constructive Theology")]), _vm._v(", with the exception of a few unnuanced, hasty rebuttals of what he considers the traditional view of the judgment of God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft23",
      "id": "fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" The "), _c('em', [_vm._v("Cambridge Companion to Postmodern Theology")]), _vm._v(" contains no entry on eschatology—the index does not even list the term! Virtual opposition to traditional eschatology comes from many quarters of women’s, particularly feminist, green, and other liberation theologians. Some analysts even consider feminist theology "), _c('em', [_vm._v("qua")]), _vm._v(" feminist as either “anti-” or “noneschatological.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft24",
      "id": "fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" While that is an overstatement, it is true that some "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("leading feminist pioneers have charged the (Christian) hope for afterlife (or “personal immortality,” as it is sometimes put) to be “a patriarchal concept arising predominantly from the male psyche,” while others argue that it necessarily neglects the destiny of the nonhuman creation and the cosmos."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Similarly, consistent opposition to all notions of the consummation of God’s kingdom after the book of Revelation has come from various types of postmodern philosophers, particularly on the more deconstructionist side on the old continent. If for Derrida “eschatology” is endless postponement without any arrival of the “Messiah,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft26",
      "id": "fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" for his (former) colleague Gilles Deleuze and those like-minded, eschatology signals the threat of totality and homogenization."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft27",
      "id": "fn27"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_c('em', [_vm._v("Some Attempts at Rediscovery and Reconceiving of Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("It is not that all twentieth-century theological movements are willing to ignore eschatology. There is also the desire to reconceive it. Some nuanced and creative contemporary alternatives have been put forth to construct a viable eschatological vision. One of the most sophisticated revisions comes from the soil of process theology’s deeply panentheistic and in many ways immanentist conception of God: therein God (in his two “dimensions,” the consequent and primordial)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft28",
      "id": "fn28"
    }
  }, [_vm._v("28")])]), _vm._v(" provides the “lure” for the future events but is not the one who guarantees an eschatological solution in any certainty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft29",
      "id": "fn29"
    }
  }, [_vm._v("29")])]), _vm._v(" There is neither an "), _c('em', [_vm._v("ex nihilo")]), _vm._v(" beginning (as God emerges with the cosmos) nor a final eschaton. Furthermore, rather than resurrection hope for humanity, there is (in the original Whiteheadian process philosophy) an idea of “objective immortality,” that is, some kind of nonpersonal recollection of us in divine memory (see "), _c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chap. 6")]), _vm._v("). Even the post-Whiteheadian attempts by some recent process theologians (Marjorie Hewitt Suchocki and others) to frame that “memory” in terms of "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“subjective immortality” are a far cry from the personal resurrection of the body of classical Christianity."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft30",
      "id": "fn30"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another marked reorientation of eschatology is the feminist theologian Kathryn Tanner’s “Eschatology without a Future” proposal (to be engaged below), which resonates with the this-worldly approach of much of New Testament scholarship, although Tanner’s reasons are theological and scientific. The main reason has to do with the obvious fact that the natural sciences’ bleak picture of all life, and the cosmos itself, seems to be heading eventually toward annihilation; hence, these scientific “end-time scenarios conflict with the future-oriented, this-worldly eschatology”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft31",
      "id": "fn31"
    }
  }, [_vm._v("31")])]), _vm._v(" of traditional Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet another highly important—as revisionist as it may be—eschatological restatement is John Hick’s 1976 magnum opus, "), _c('em', [_vm._v("Death and Eternal Life")]), _vm._v(". Mapping a huge domain of ideas among various religious traditions and in the tradition of Christian theology, he sets forth a creative synthesis between some living Asiatic faiths and a Judeo-Christian vision. He also staunchly opposes the prevailing naturalistic rebuttal of religious eschatologies: “In contrast to it,” Hick states, “it seems to me that the claim of the religions that this life is part of a much larger existence that transcends our lifespan as animal organisms, whether through the continuation of individual consciousness or through participation in a greater transpersonal life, is very likely to be true.” He further argues, “this is not ruled out by established scientific findings or by any agreed philosophical arguments.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft32",
      "id": "fn32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although the current project cannot follow the material proposals of these and related revisionist eschatologies, it learns from them and constantly invites them as dialogue partners. Coming closest to the intuitions of this constructive theology are the many contemporary proposals that stay closely linked with the best of Christian tradition even when they seek to challenge and revise them. To a brief presentation of those we turn next.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_c('em', [_vm._v("“Something Old, Something New”: The Rise of Constructive Christian Eschatologies")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In the midst of the dismissal and radical reworking of the doctrine of last things, some leading contemporary theologians have helped rediscover eschatology and even put it at the center of theological conversations. Barth’s "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("classic rediscovery of eschatology is routinely mentioned as the clarion call: he claimed that without eschatology, no theology is worth its salt."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v(" The publication of German Reformed theologian J. Moltmann’s "), _c('em', [_vm._v("Theology of Hope")]), _vm._v(" in the mid-1960s launched a new movement called “theology of hope.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft34",
      "id": "fn34"
    }
  }, [_vm._v("34")])]), _vm._v(" For him, eschatology is the “first” chapter of Christian theology. Another German, the Lutheran W. Pannenberg, talks about the “causal priority of the future”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft35",
      "id": "fn35"
    }
  }, [_vm._v("35")])]), _vm._v(" and makes the surprising and counterintuitive claim of “the present as an effect of the future, in contrast to the conventional assumption that past and present are the cause of the future.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft36",
      "id": "fn36"
    }
  }, [_vm._v("36")])]), _vm._v(" Because of that, for Pannenberg the concept of anticipation of the future became a leading theme:"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft37",
      "id": "fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" the historical resurrection of Jesus Christ as a “proleptic” event makes Christian hope confident (albeit not yet fully determined) of the coming eschatological consummation on which ultimately hinges the truth of the Christian message."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft38",
      "id": "fn38"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several Americans have joined the turn to the future, including the two Lutherans, Ted Peters, with his concept of “retroactive ontology” materially repeating Pannenberg’s futuristic causality,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft39",
      "id": "fn39"
    }
  }, [_vm._v("39")])]), _vm._v(" and Robert W. Jenson, to whom God’s true “triune identity” can be known in the course of history’s unfolding toward consummation, in which process God shows his faithfulness."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft40",
      "id": "fn40"
    }
  }, [_vm._v("40")])]), _vm._v(" Yet another American, the Anabaptist Thomas N. Finger, not only makes room for eschatology in his doctrinal presentation but even gives it the primary place by making it the leading theme."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft41",
      "id": "fn41"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The British Anglican New Testament scholar N. T. Wright has labored for decades not only with issues such as resurrection but also, more recently, with the biblical basis of future hope. He has been recently joined by another senior New Testament expert, A. Thiselton."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft42",
      "id": "fn42"
    }
  }, [_vm._v("42")])]), _vm._v(" Some leading science-religion "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("experts, particularly the British physicist-priest John Polkinghorne and the American physicist-theologian Robert J. Russell, in collaboration with systematicians such as the German Michael Welker, have done groundbreaking work in helping rediscover the centrality of eschatology after the advent of modern science. And so forth. This is to say that with all the push toward ignoring eschatology in some theological quarters, in others it is alive and well."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft43",
      "id": "fn43"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not only in theology but also among the Christian communities, particularly when looked at from a global perspective, eschatology has returned. Whereas in the Global North on the old continent, eschatology rarely plays a visible role in churches’ spirituality and liturgy, large sections of American Christianity still cultivate a vital hope for the return of Christ, not only among the fundamentalists but also beyond."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft44",
      "id": "fn44"
    }
  }, [_vm._v("44")])]), _vm._v(" Furthermore—and this is routinely ignored and dismissed in academic theology—among majority world Christianity (Africa, Asia, Latin America), where churches are mushrooming and flourishing, eschatological proclamation still is very much a part of the daily tapestry of spirituality.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_c('strong', [_vm._v("On the Conditions and Requirements of a Comprehensive Eschatology")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-t0",
    attrs: {
      "id": "sec2-5"
    }
  }, [_c('em', [_vm._v("What Is Eschatology All About?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Although the equivalent of the term “eschatology,” the Latin "), _c('em', [_vm._v("de novissimis")]), _vm._v(" (“the last things”), was used much earlier, only at the time of Protestant orthodoxy, in the "), _c('em', [_vm._v("Loci theologici")]), _vm._v(" (1610–1621) of the Lutheran Johann Gerhard, did the topic receive a full-scale treatment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft45",
      "id": "fn45"
    }
  }, [_vm._v("45")])]), _vm._v(" A few decades later the term "), _c('em', [_vm._v("eschatologia")]), _vm._v(" itself was used in the last volume of another Lutheran scholastic, Abraham Calov’s "), _c('em', [_vm._v("Systema locorum theologicorum")]), _vm._v(" (1655–1677)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft46",
      "id": "fn46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Recently, Hick has introduced the terminological distinction between “eschatology” and “pareschatology,” the former relating to the ultimate consummation and the latter to everything “in-between,” that is, during the “intermediate” "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("period (if any) between one’s death and the consummation of everything."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft47",
      "id": "fn47"
    }
  }, [_vm._v("47")]), _vm._v(" This distinction, although not widely used (even in this project), makes the useful point that eschatology’s domain is huge and comprehensive: “In its broadest sense the term ‘eschatology’ includes all concepts of life beyond death and everything connected with it such as heaven and hell, paradise and immortality, resurrection and transmigration of the soul, rebirth and reincarnation, and last judgment and doomsday.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft48",
      "id": "fn48"
    }
  }, [_vm._v("48")])]), _vm._v(" Christian eschatology, however, is less about explorations into the sequence of events in the future and more “about a "), _c('em', [_vm._v("good")]), _vm._v(" future,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft49",
      "id": "fn49"
    }
  }, [_vm._v("49")])]), _vm._v(" the content of hope. For that, it must assume that “we live in a world that makes sense not just now, but totally and forever.” Then, and only then, the awaited end is a “fulfillment of the history of the universe and the history of humanity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft50",
      "id": "fn50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Christian theology has to try to strike a radical balance between the New Testament type of enthusiastic hope for the coming of God’s righteous rule and the fact that, simply put, “we are no longer a young religion looking forward to the imminent coming of Christ, as the members of the nascent church did in the first centuries.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft51",
      "id": "fn51"
    }
  }, [_vm._v("51")])]), _vm._v(" As the German Lutheran theologian Hans Schwarz puts it, “we must guard against two frequent temptations: undue restraint and a travelogue eschatology.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft52",
      "id": "fn52"
    }
  }, [_vm._v("52")])]), _vm._v(" It is instructive to note that while on the one hand the Christian Bible has eschatological-apocalyptic sections, and even a whole book devoted to the topic in the New Testament, the church also wisely left out from its canon such wildly speculative and fantasy-oriented pieces of literature as the "), _c('em', [_vm._v("Book of Enoch")]), _vm._v(" and the "), _c('em', [_vm._v("Apocalypse of Paul")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft53",
      "id": "fn53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Seeking for the middle path between the two extremes, however, should not frustrate or push into the margins the radical nature of eschatological hope: “Eschatological faith has about it an undeniable defiance of commonsense appearances. In the face of suffering, violence, and seemingly hopeless injustice and tragedy, it is bold to believe that these are not the deepest and truest realities.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft54",
      "id": "fn54"
    }
  }, [_vm._v("54")])]), _vm._v(" Particularly resurrection “requires of faith something even more terrible than submission before the violence of being and acceptance of fate, and forbids faith the consolations of tragic wisdom; it places all hope and "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("consolation upon the insane expectation that what is lost will be given back, not as heroic wisdom (death has been robbed of its tragic beauty) but as the gift it always was.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft55",
      "id": "fn55"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But what is the “end” eschatology speaks of? A notoriously polyvalent term, “end” can mean both completion (that is, coming or bringing to an end)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft56",
      "id": "fn56"
    }
  }, [_vm._v("56")])]), _vm._v(" or fulfillment (as in the Greek term "), _c('em', [_vm._v("telos")]), _vm._v("). Both meanings are present in the Christian eschatological expectation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft57",
      "id": "fn57"
    }
  }, [_vm._v("57")])]), _vm._v(" P. Tillich saw this in his highly nuanced discussion of “the kingdom of God as the end of history,” minding the dual nature of the term “end” as completion and fulfillment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft58",
      "id": "fn58"
    }
  }, [_vm._v("58")])]), _vm._v(" Stating that although “[p]ast and present meet in the present, and both are included in the eternal ‘now,’ … they are not swallowed by the present,” he added that the future reference is not thereby ignored."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft59",
      "id": "fn59"
    }
  }, [_vm._v("59")])]), _vm._v(" This sounds good and correct. Where Tillich goes astray, however, is when he argues that “the fulfillment of history lies in the permanently present end of history,” leading to the disappointing thesis that, therefore, ultimately “[t]he eternal is not a future state of things; it is always present.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft60",
      "id": "fn60"
    }
  }, [_vm._v("60")])]), _vm._v(" To say that the eternal is not a future state of things is of course true in one sense; eternity is “much more” than a temporal state of things; however, to say that alone (in Tillich’s system) means that there is not a future in the sense that traditional eschatology intuits."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft61",
      "id": "fn61"
    }
  }, [_vm._v("61")])]), _vm._v(" Tillich’s abandonment of the future, final fulfillment of God’s kingdom is but an example of the wide trend in the twentieth-century eclipse of future-oriented eschatology."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft62",
      "id": "fn62"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On top of the meaningfulness of creation, three essential aspects should be integrated tightly into any constructive eschatology: first, the hope not only for the human future but also for the transformation and renewal of all creatures and the cosmos itself; second, hope for both persons and communities, including the whole of humanity; and third, hope for both the afterlife and the life-before-afterlife.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('em', [_vm._v("The Domain and Horizon of a Constructive Eschatology")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("At the very center of Christian hope is “participation in the eternal life of God.… [And all] else that is related to it, including the resurrection of the dead and the last judgment, is a consequence of God’s own coming to consummate his rule over his creation.” This “future of God’s kingdom,” the “epitome of Christian hope,”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft63",
      "id": "fn63"
    }
  }, [_vm._v("63")]), _vm._v(" encompasses all of creation, not only humans, nor merely Earth—but the whole vast cosmos. This is the proper framework for eschatology. This widest horizon, however, has not been at the center of Christian eschatology. Indeed, what happened early in Christian theology was that personal eschatology became the focus of the Christian hope. And the concept of the kingdom of God was soon marginalized. Even worse, when employed, its meaning was reduced mainly to hope for the personal resurrection of the body. Communal and cosmic horizons were marginalized. A telling example can be found in the eighth-century (Eastern) doctrinal manual "), _c('em', [_vm._v("The Orthodox Faith")]), _vm._v(" by John of Damascus, in which the whole concept of the kingdom is missing and individual resurrection is made the defining theme. The same is true of Western doctrinal presentations from Lombard’s "), _c('em', [_vm._v("Distinctions")]), _vm._v(" all the way to the Reformation and Protestant Scholasticism. Even classical liberalism’s rediscovery of the kingdom of God ended in an immanentist and personalist interpretation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft64",
      "id": "fn64"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Only in twentieth-century theology have the centrality and comprehensive nature of eschatology been rediscovered, including not only the personal but also the communal. But even here, a key weakness can still be discerned: the lack of a cosmic orientation. Whereas Barth succeeded in helping rediscover the centrality of eschatology to theology, only in the theologies of Rahner, Moltmann, and Pannenberg, among others, have the implications of what we know of the vastness of the cosmos—in terms of size, “age,” and expansion—begun to emerge as integral themes. But even in them the "), _c('em', [_vm._v("cosmic")]), _vm._v(" orientation is still by and large in the making.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The development of a viable constructive eschatology for the sake of the religiously pluralistic and secular culture of the globalizing world has to encompass the following spheres:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("personal and communal hope")]), _vm._v(" "), _c('li', [_vm._v("human and cosmic destiny")]), _vm._v(" "), _c('li', [_vm._v("present and future hope")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('em', [_vm._v("Personal and Communal Hope")]), _vm._v(". A systematically crucial problem for constructive eschatology is negotiating personal and communal hopes (ultimately relating to the whole human race) not only as parallel with each other but also as mutually linked. Only such an eschatology that can successfully envision “the perfecting of individual life after death … with the consummation of humanity and world in the kingdom of God” will suffice."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft65",
      "id": "fn65"
    }
  }, [_vm._v("65")]), _vm._v(" Unless one is willing to go with the idea of physical death as an immediate entrance to God’s eternity (without any “intermediate time”), a way has to be found to link one’s own death and bodily resurrection with the rest of humanity. The theological options are these: “"), _c('em', [_vm._v("Either")]), _vm._v(" we expect full and real personal salvation at death even though this minimizes what takes place at the end, allowing for it nothing decisive for individual fulfillment and giving it the significance of an addition, since everything decisive has taken place already; "), _c('em', [_vm._v("or")]), _vm._v(" we expect the real decision and salvation to come only at the last day, though this is to play down death as access to Christ, as decision, as purifying, and as transformation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft66",
      "id": "fn66"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Old Testament and Jewish tradition, the communal hope lay in the forefront and the individual emerged only later gradually (see "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#ch-3"
    }
  }, [_vm._v("chap. 3")]), _vm._v("). Even when the hope for individuals developed, it was not divorced from but rather integrated into the hope for all of humanity. The Christian church adopted this view and faced the task of even expanding it with the inclusion of Gentiles into the hope for a common destiny. In comparison, the pagan hope of the immortality of the soul (as in Plato) has no reference to the whole of humanity, only to the individual. Nor is the contemporary secular hope for the completion of human dreams in an ideal society, as expressed particularly in Marxism, successful in conceiving this utopia as for the whole of humanity; it only deals with those currently living; those who have passed away will totally miss it. The idealist philosopher Gotthold Lessing clearly understood that in his "), _c('em', [_vm._v("Education of the Human Race")]), _vm._v(" and was led to the idea of reincarnation for its solution."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft67",
      "id": "fn67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The solution of Christian tradition to this dilemma is based on the trinitarian faith, particularly on pneumatological resources. Similarly to the related locus of soteriology and ecclesiology, it is the Spirit’s work to “lift us” up in filial relationship with Jesus Christ, the Savior, but not only as individuals without an integral link with others, but rather as members of the same “body” whose "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“head” is Christ. This “ecstatic” (as in “standing outside one’s self”) work of the Spirit is of course already at work in a different manner in creation, linking all creatures to the rest of creation."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft68",
      "id": "fn68"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Human and Cosmic Destiny")]), _vm._v(". Although he himself failed to carry out the program, Tillich’s demand that the basic dilemma of any eschatology—the relationship between the individual and collective hope—should not be “separated from the destiny of the universe”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft69",
      "id": "fn69"
    }
  }, [_vm._v("69")])]), _vm._v(" is definitely pointing in the right direction. Christian hope of the eschatological consummation includes the whole of God’s creation, “the integration of the real history of human beings with the nature of the earth.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft70",
      "id": "fn70"
    }
  }, [_vm._v("70")])]), _vm._v(" This holistic and “earthly” eschatological vision is masterfully expressed by the American Anabaptist theologian Thomas A. Finger: “Since the new creation arrives through God’s Spirit, and since it reshapes the physical world, every theological locus is informed by the Spirit’s transformation of matter-energy.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft71",
      "id": "fn71"
    }
  }, [_vm._v("71")])]), _vm._v(" Christ’s resurrection through the life-giving Spirit is already a foretaste of the “transformation of matter-energy” in new creation, “a transformation of the present nature beyond what emergence refers to.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft72",
      "id": "fn72"
    }
  }, [_vm._v("72")])]), _vm._v(" The pneumatologically loaded eschatological openness of creation points to the final consummation in which matter and physicality—no more than time—are not so much “deleted” as transformed, made transcendent, so to speak."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft73",
      "id": "fn73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Present and Future Hope")]), _vm._v(". The present and future are linked tightly with each other through the presence of the Spirit: “By the Spirit the eschatological future is present already in the hearts of believers. His dynamic is the basis of anticipations of eschatological salvation already in the as yet incomplete history of the world.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft74",
      "id": "fn74"
    }
  }, [_vm._v("74")])]), _vm._v(" This is a corrective to merely this-worldly “eschatologies,” whether those of classical liberalism and other Enlightenment-driven traditions or contemporary eco-feminist (and some liberationist) views. It is also a defeat of those fundamentalist and other otherworldly eschatological visions that end up being escapist and dismissive of work toward improving the current world. The “already” and “not yet” (of the arrival of the kingdom of God) and the “continuity” versus “discontinuity” (between new creation and this world) templates hold the present and future in dynamic tension "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("and mutual conditioning. R. Russell summarizes it succinctly: “Eschatologies such as these view the new creation not as a replacement of the present creation—i.e., not as a second "), _c('em', [_vm._v("ex nihilo")]), _vm._v("—nor as the mere working out of the natural processes of the world. Instead eschatology involves the complete transformation of the world by a radically new act of God beginning at Easter and continuing into the future.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft75",
      "id": "fn75"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The demand for such a comprehensive and all-embracing eschatology raises questions as to the nature of language and approach. Similar kinds of challenges can be found in other theological loci, particularly in the doctrine of creation, as it also engages not only Christian tradition and other faith traditions but also natural sciences and their particular ways of discourse. Eschatology has also its own peculiar challenges, to which we turn next, before outlining the plan of "), _c('a', {
    attrs: {
      "href": "#/008_Part01#pt-1"
    }
  }, [_vm._v("part 1")]), _vm._v(".")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-7"
    }
  }, [_c('em', [_vm._v("Metaphors and Participation: On the Nature of Knowledge of Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Moltmann makes the obvious point that any claim for "), _c('em', [_vm._v("logos")]), _vm._v(", “teaching,” “doctrine,” “principle” about eschaton, events yet-to-happen, is quite a precarious assertion!"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft76",
      "id": "fn76"
    }
  }, [_vm._v("76")])]), _vm._v(" Rather, we could speak of “the believing hope.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft77",
      "id": "fn77"
    }
  }, [_vm._v("77")])]), _vm._v(" That kind of discourse, however, is hardly analytic and doctrinal; it is rather suggestive, metaphorical, testimonial, narrative. No wonder much of the New Testament teaching on eschatology, as the late American Baptist theologian James McClendon put it, comes to us in the form of “word pictures,” “words that present visual scenes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft78",
      "id": "fn78"
    }
  }, [_vm._v("78")])]), _vm._v(" Hence, he recommends “eschatological picture thinking” as a methodological guide: therein the theologian engages various biblical (and historical) pictures of God’s eschatological rule to show that eschatology is both an image of the end and a directive for the church’s present: eschatology is concerned “with what lasts and with what comes last.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft79",
      "id": "fn79"
    }
  }, [_vm._v("79")])]), _vm._v(" Similarly, the Jewish theologian Neil Gillman says: “All eschatologies are imaginative constructs. They must be imaginative not only because they deal with events that no human "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("has ever beheld, but even more because these events will inaugurate an age which is properly timeless.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft80",
      "id": "fn80"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Add to those caveats yet another obvious one, namely, the vast size of the observed cosmos as we now know it. Speaking of its “end” and “destiny”—which we must attempt in contrast to earlier anthropocentric (and our-planet-centered) approaches—in light of its immensity should lead us into humble, tentative, and suggestive concepts."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft81",
      "id": "fn81"
    }
  }, [_vm._v("81")])]), _vm._v(" Not only that, but there is yet another layer of challenges to any serious talk about eschatology, what the Italian liberationist Vítor Westhelle names as its liminality, in three interrelated senses of the term—ontologically, ethically, and epistemologically: “Eschatology is a discourse on liminality, on that which is different in an ontological, ethical and also epistemological sense. Ontologically, because it addresses the question of an Other reality, as different as the reality of God is from this world; ethically, because it pertains to a different code for morality, as different as the Sermon on the Mount is from all our ethical systems and moral prescriptions; epistemologically, because eschatology is also about the liminality of our accepted epistemic régimes, i.e., that there are other, often-suppressed ‘knowledges’ beyond the commonly accepted noetic realm of the academy.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft82",
      "id": "fn82"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In light of these considerations, there is some value in Moltmann’s proposal that a constructive theology of creation (and by implication, eschatology) “must try to get away from analytical thinking, with its distinctions between subject and object.… This means that it will have to revert to the premodern concept of reason as the organ of perception and participation (methexis).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft83",
      "id": "fn83"
    }
  }, [_vm._v("83")])]), _vm._v(" Closely related to the metaphoric orientation is participatory knowledge that seeks not to possess but rather to gratefully participate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft84",
      "id": "fn84"
    }
  }, [_vm._v("84")])]), _vm._v(" Participatory knowledge honors the relational, mutually dependent, and symbiotic nature of all created processes, including humanity as part of it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft85",
      "id": "fn85"
    }
  }, [_vm._v("85")])]), _vm._v(" While Moltmann’s suggestion is useful, it also calls for some qualification and correction. First, a return to a communicative and participatory knowledge does not have to mean the return to a premodern concept of reason—how could we return, living as we are on this side of the Enlightenment? Second, participatory knowledge does not have to be antagonistic to analytical thinking; a quick look at leading "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("theologians in tradition leaves no doubt about sophisticated intellectual and analytic capacities in the service of a “premodern” doctrinal formation. Furthermore, as the evolutionary biologist Jeffrey P. Schloss reminds us, “even in their figurativeness, metaphors are metaphors of something, not nothing.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ft86",
      "id": "fn86"
    }
  }, [_vm._v("86")]), _vm._v(" The use of metaphors is not funded by the desire to know “less” or more vaguely about eschatology, but rather, to try to be sensitive to the distinctive requirements of that “knowledge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although theologians should be quick to acknowledge the limits of human language and intellectual powers, they should also not capitulate before the bar of reason. Consider what A. McGrath, a leading expert on religion-science dialogue, states: “From a Christian perspective, the horizons defined by the parameters of our human existence merely limit what we can see; they do not define what there is to be seen.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ft87",
      "id": "fn87"
    }
  }, [_vm._v("87")])]), _vm._v(" Theological imagination, as much as it has to be anchored in the wider human pursuit of truth, should bravely, though also carefully, rush in where angels fear to tread. Modern and contemporary theologians have so much feared the fame of the fool that they also often lacked the rewards of the discovery of the radically new and unanticipated.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-3"
    }
  }, [_c('strong', [_vm._v("Orientation to "), _c('a', {
    attrs: {
      "href": "#/008_Part01#pt-1"
    }
  }, [_vm._v("Part 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ch-2"
    }
  }, [_vm._v("Chapters 2")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#ch-3"
    }
  }, [_vm._v("3")]), _vm._v(", respectively, will present the visions of the “end” of the cosmos and human life as conjectured among natural sciences and as envisioned in four living faiths. With regard to the sciences, clarifications of what is at stake theologically will be carefully considered. A number of subsequent chapters will reflect on natural sciences’ implications for theological claims. Religions’ eschatologies will not yet be engaged from a Christian point of view; that will happen in later chapters incrementally, in relation to topics relevant for a given faith tradition. The discussion in "), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#ch-3"
    }
  }, [_vm._v("chapter 3")]), _vm._v(" seeks to provide as coherent and representative a view of Jewish, Muslim, Buddhist, and Hindu eschatologies as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As a theological prelude to the rest of the presentation of a Christian view of the “end” and the consummation, "), _c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(" outlines a trinitarian theology of hope—similar to what was done with regard to, say, the doctrine of revelation ("), _c('em', [_vm._v("Trinity and Revelation")]), _vm._v(", chap. 2) and of creation ("), _c('em', [_vm._v("Creation and Humanity")]), _vm._v(", chap. 4). Thereafter, two long chapters ("), _c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(") will seek to develop "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("and defend a comprehensive Christian vision of the transition from this world to new creation, paying special attention to how to conceive this transition in relation to the time-space continuum, which obviously has to be radically transformed; to the transposition from the state of decay and death to one of life in the resurrected body; and to the role of judgment and purification as necessary conditions for living in the holiness of God. A particularly complex problem of the identity-continuity between now and “then” in relation to the hope for physical resurrection will also be inspected.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 7")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/016_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" will take up issues only marginally (if at all) discussed in systematic/constructive eschatologies: first, the value of nature and the environment, as well as justice and equality, in relation to hope for life eternal. How should a constructive theology defeat the persistent critique of eco-feminists and other environmentally sensitive theologians to whom the Christian vision of the end represents egoism and leads to dismissal of this earthly life? Liberationists of various stripes echo the same charge by claiming that Christian eschatology lacks resources for tackling current problems in society in its hope for a better world to come. Second, a related issue, the presence of evil and suffering in a world created good, has to be carefully investigated—as does the corollary issue of violence in relation to the promise in biblical teaching of defeating all resisting powers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In "), _c('span', {
    attrs: {
      "href": "#/017_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v(", the difficult and complex questions related to access to eternal salvation and the possibility of eternal condemnation will be reflected on in light of Christian tradition and contemporary theological and religious plurality. The last chapter in "), _c('a', {
    attrs: {
      "href": "#/008_Part01#pt-1"
    }
  }, [_vm._v("part 1")]), _vm._v(" takes up the remaining standard issues regarding final consummation, from the signs of Jesus’ return, to its nature and significance, to the possibility of the earthly millennial rule of Christ, to the nature of heaven and new creation. In particular, the last topic will be carefully considered in light of dramatic intellectual, cultural, and theological shifts in the last century.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "ft1"
    }
  }, [_vm._v("1")]), _vm._v(". As has been famously argued by Eliade, "), _c('em', [_vm._v("The Myth of the Eternal Return")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn2",
      "id": "ft2"
    }
  }, [_vm._v("2")]), _vm._v(". See Körtner, "), _c('em', [_vm._v("The End of the World")]), _vm._v(", pp. 1–22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn3",
      "id": "ft3"
    }
  }, [_vm._v("3")]), _vm._v(". A groundbreaking essay was Rees’s “Collapse of the Universe.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn4",
      "id": "ft4"
    }
  }, [_vm._v("4")]), _vm._v(". Schloss, “From Evolution to Eschatology,” pp. 71–79.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn5",
      "id": "ft5"
    }
  }, [_vm._v("5")]), _vm._v(". Gillman, "), _c('em', [_vm._v("The Death of Death")]), _vm._v(", p. 21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn6",
      "id": "ft6"
    }
  }, [_vm._v("6")]), _vm._v(". Gillman, "), _c('em', [_vm._v("The Death of Death")]), _vm._v(", p. 21, attributing the idea to Herberg, "), _c('em', [_vm._v("Judaism and Modern Man")]), _vm._v(", pp. 230–31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn7",
      "id": "ft7"
    }
  }, [_vm._v("7")]), _vm._v(". Nietzsche, "), _c('em', [_vm._v("Use and Abuse of History")]), _vm._v(", p. 71.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn8",
      "id": "ft8"
    }
  }, [_vm._v("8")]), _vm._v(". Ausmus, “Nietzsche and Eschatology,” p. 347.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn9",
      "id": "ft9"
    }
  }, [_vm._v("9")]), _vm._v(". Nietzsche, "), _c('em', [_vm._v("Beyond Good and Evil")]), _vm._v(", p. 46, cited in Ausmus, “Nietzsche and Eschatology,” p. 351.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn10",
      "id": "ft10"
    }
  }, [_vm._v("10")]), _vm._v(". Fukuyama, "), _c('em', [_vm._v("The End of History and the Last Man")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn11",
      "id": "ft11"
    }
  }, [_vm._v("11")]), _vm._v(". Hardt and Negri, "), _c('em', [_vm._v("Empire")]), _vm._v(" and "), _c('em', [_vm._v("Multitude")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn12",
      "id": "ft12"
    }
  }, [_vm._v("12")]), _vm._v(". Daley, “Eschatology in the Early Church Fathers,” pp. 92–94. A massive resource is his "), _c('em', [_vm._v("Hope of the Early Church")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn13",
      "id": "ft13"
    }
  }, [_vm._v("13")]), _vm._v(". Just consider the influential early second-century writings the "), _c('em', [_vm._v("Apocalypse of Peter")]), _vm._v(" and "), _c('em', [_vm._v("Epistle of the Apostles")]), _vm._v(", which discuss extensively end-time events. For the centrality of apocalypticism, see Daley, “Apocalypticism in Early Christian Theology.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn14",
      "id": "ft14"
    }
  }, [_vm._v("14")]), _vm._v(". See further Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:532–45.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn15",
      "id": "ft15"
    }
  }, [_vm._v("15")]), _vm._v(". See Kant, "), _c('em', [_vm._v("Religion within the Limits of Reason Alone")]), _vm._v(", p. 102.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn16",
      "id": "ft16"
    }
  }, [_vm._v("16")]), _vm._v(". For a succinct discussion with basic original sources, see J. Walls, introduction to "), _c('em', [_vm._v("OHE")]), _vm._v(", pp. 7–9; even for Walls, the significance of said New Testament scholars is overrated.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn17",
      "id": "ft17"
    }
  }, [_vm._v("17")]), _vm._v(". Feuerbach, "), _c('em', [_vm._v("Essence of Christianity")]), _vm._v(", pp. 170–84 particularly.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn18",
      "id": "ft18"
    }
  }, [_vm._v("18")]), _vm._v(". For details and sources, see Schwarz, "), _c('em', [_vm._v("Eschatology")]), _vm._v(", pp. 176–77.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn19",
      "id": "ft19"
    }
  }, [_vm._v("19")]), _vm._v(". Freud, "), _c('em', [_vm._v("Reflections on War and Death")]), _vm._v(", p. 19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn20",
      "id": "ft20"
    }
  }, [_vm._v("20")]), _vm._v(". B. Russell, "), _c('em', [_vm._v("Why I Am Not a Christian")]), _vm._v(", p. 45, cited in Raphael, "), _c('em', [_vm._v("Jewish Views of the Afterlife")]), _vm._v(", p. 23; see also Linda Badham, who remains deeply skeptical and provides a thoughtful case for a naturalistic denial of any afterlife: “A Naturalistic Case for Extinction,” pp. 158–70.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn21",
      "id": "ft21"
    }
  }, [_vm._v("21")]), _vm._v(". For an accessible account, see Flew, “The Logic of Mortality,” pp. 171–87.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn22",
      "id": "ft22"
    }
  }, [_vm._v("22")]), _vm._v(". See Borg, "), _c('em', [_vm._v("Jesus in Contemporary Scholarship")]), _vm._v(", pp. 47–68; Borg, "), _c('em', [_vm._v("Jesus, A New Vision")]), _vm._v(". For criticism, see Witherington, "), _c('em', [_vm._v("Jesus, Paul, and the End of the World")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn23",
      "id": "ft23"
    }
  }, [_vm._v("23")]), _vm._v(". See Kaufman, "), _c('em', [_vm._v("In Face of Mystery")]), _vm._v(", p. 409; I am indebted to Schwarz, "), _c('em', [_vm._v("Eschatology")]), _vm._v(", p. 366.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn24",
      "id": "ft24"
    }
  }, [_vm._v("24")]), _vm._v(". Cf. Karras, “Eschatology,” pp. 244–45.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn25",
      "id": "ft25"
    }
  }, [_vm._v("25")]), _vm._v(". Karras, “Eschatology,” pp. 243–44 (244); C. Keller, “Eschatology, Ecology, and a Green Ecumenacy,” pp. 84–99.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn26",
      "id": "ft26"
    }
  }, [_vm._v("26")]), _vm._v(". Derrida, “Hospitality, Justice, and Responsibility,” p. 70; see also his comment on the continuing “openness” of the future in Derrida, “Faith and Knowledge,” p. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn27",
      "id": "ft27"
    }
  }, [_vm._v("27")]), _vm._v(". Deleuze, “Nietzsche and Saint Paul,” pp. 36–53.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn28",
      "id": "ft28"
    }
  }, [_vm._v("28")]), _vm._v(". Griffin, “Process Eschatology,” p. 297, with the citation from Whitehead, "), _c('em', [_vm._v("Process and Reality")]), _vm._v(", p. 527.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn29",
      "id": "ft29"
    }
  }, [_vm._v("29")]), _vm._v(". See Cobb, "), _c('em', [_vm._v("Christ in a Pluralistic Age")]), _vm._v(", chaps. 15 and 16; for a comparison between Whitehead’s (as also developed theologically by Cobb himself) and Pannenberg’s (in comparison, traditional Christian) eschatology, see pp. 246–54 particularly.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn30",
      "id": "ft30"
    }
  }, [_vm._v("30")]), _vm._v(". See Griffin, “Process Eschatology,” pp. 295–307.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn31",
      "id": "ft31"
    }
  }, [_vm._v("31")]), _vm._v(". Tanner, “Eschatology without a Future,” p. 222.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn32",
      "id": "ft32"
    }
  }, [_vm._v("32")]), _vm._v(". Hick, "), _c('em', [_vm._v("Death and Eternal Life")]), _vm._v(", p. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn33",
      "id": "ft33"
    }
  }, [_vm._v("33")]), _vm._v(". The most often referred to statement is in Barth, "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(", p. 314.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn34",
      "id": "ft34"
    }
  }, [_vm._v("34")]), _vm._v(". For a brief discussion, see Kärkkäinen, “Hope, Theology of,” pp. 404–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn35",
      "id": "ft35"
    }
  }, [_vm._v("35")]), _vm._v(". So named by R. Russell, "), _c('em', [_vm._v("Time in Eternity")]), _vm._v(", pp. 117–19; Pannenberg first outlined it in "), _c('em', [_vm._v("Theology and the Kingdom of God")]), _vm._v(", chaps. 1 and 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn36",
      "id": "ft36"
    }
  }, [_vm._v("36")]), _vm._v(". Pannenberg, "), _c('em', [_vm._v("Theology and the Kingdom of God")]), _vm._v(", p. 54, cited in R. Russell, "), _c('em', [_vm._v("Time in Eternity")]), _vm._v(", p. 118.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn37",
      "id": "ft37"
    }
  }, [_vm._v("37")]), _vm._v(". For a fine synopsis, see R. Russell, "), _c('em', [_vm._v("Time in Eternity")]), _vm._v(", pp. 119–22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn38",
      "id": "ft38"
    }
  }, [_vm._v("38")]), _vm._v(". See further LaBute, “The Ontological Motif of Anticipation,” pp. 275–82; Harvie, “Living the Future,” pp. 149–64.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn39",
      "id": "ft39"
    }
  }, [_vm._v("39")]), _vm._v(". Peters, "), _c('em', [_vm._v("Anticipating Omega")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn40",
      "id": "ft40"
    }
  }, [_vm._v("40")]), _vm._v(". Jenson, "), _c('em', [_vm._v("The Triune Identity")]), _vm._v(". See also the Reformed American Donald G. Bloesch, "), _c('em', [_vm._v("The Last Things.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn41",
      "id": "ft41"
    }
  }, [_vm._v("41")]), _vm._v(". T. Finger, "), _c('em', [_vm._v("Christian Theology")]), _vm._v(". For the centrality of eschatology for twentieth-century theology, see Hebblethwaite, "), _c('em', [_vm._v("The Christian Hope")]), _vm._v(", pp. 131–98.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn42",
      "id": "ft42"
    }
  }, [_vm._v("42")]), _vm._v(". Thiselton, "), _c('em', [_vm._v("Life after Death")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn43",
      "id": "ft43"
    }
  }, [_vm._v("43")]), _vm._v(". For a highly useful presentation and assessment of typologies of contemporary eschatology, see Conradie, "), _c('em', [_vm._v("Hope for the Earth")]), _vm._v(", chap. 13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn44",
      "id": "ft44"
    }
  }, [_vm._v("44")]), _vm._v(". For details regarding the two continents, see Schwarz, "), _c('em', [_vm._v("Eschatology")]), _vm._v(", pp. 1–2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn45",
      "id": "ft45"
    }
  }, [_vm._v("45")]), _vm._v(". Gerhard, "), _c('em', [_vm._v("Loci theologici")]), _vm._v(" (1610–1621), devotes no fewer than two of nine books to the detailed discussion of eschatological topics (books 8 and 9).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn46",
      "id": "ft46"
    }
  }, [_vm._v("46")]), _vm._v(". For the historical background and contemporary role of eschatology, see Sauter, “The Concept and Task of Eschatology,” pp. 499–515.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn47",
      "id": "ft47"
    }
  }, [_vm._v("47")]), _vm._v(". Hick, "), _c('em', [_vm._v("Death and Eternal Life")]), _vm._v(", p. 399 and passim.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn48",
      "id": "ft48"
    }
  }, [_vm._v("48")]), _vm._v(". Schwarz, "), _c('em', [_vm._v("Eschatology")]), _vm._v(", p. 26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn49",
      "id": "ft49"
    }
  }, [_vm._v("49")]), _vm._v(". Watts, “Subjective and Objective Hope,” p. 48, emphasis in original.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn50",
      "id": "ft50"
    }
  }, [_vm._v("50")]), _vm._v(". Polkinghorne, "), _c('em', [_vm._v("God of Hope")]), _vm._v(", pp. xvii, xvi.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn51",
      "id": "ft51"
    }
  }, [_vm._v("51")]), _vm._v(". Schwarz, "), _c('em', [_vm._v("Eschatology")]), _vm._v(", p. xii.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn52",
      "id": "ft52"
    }
  }, [_vm._v("52")]), _vm._v(". Schwarz, "), _c('em', [_vm._v("Eschatology")]), _vm._v(", p. 247.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn53",
      "id": "ft53"
    }
  }, [_vm._v("53")]), _vm._v(". Schwarz, "), _c('em', [_vm._v("Eschatology")]), _vm._v(", p. 247.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn54",
      "id": "ft54"
    }
  }, [_vm._v("54")]), _vm._v(". J. Walls, introduction to "), _c('em', [_vm._v("OHE")]), _vm._v(", p. 5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn55",
      "id": "ft55"
    }
  }, [_vm._v("55")]), _vm._v(". D. Hart, "), _c('em', [_vm._v("The Beauty of the Infinite")]), _vm._v(", p. 392, as cited in J. Walls, introduction to "), _c('em', [_vm._v("OHE")]), _vm._v(", p. 6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn56",
      "id": "ft56"
    }
  }, [_vm._v("56")]), _vm._v(". Kant famously problematized the idea of “end” in this sense and rightly intuited that the idea of time coming to an end greatly challenges our mental powers. See Kant, “The End of All Things,” pp. 221–22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn57",
      "id": "ft57"
    }
  }, [_vm._v("57")]), _vm._v(". See Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:586–87.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn58",
      "id": "ft58"
    }
  }, [_vm._v("58")]), _vm._v(". Tillich, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:394.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn59",
      "id": "ft59"
    }
  }, [_vm._v("59")]), _vm._v(". Tillich, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:395–96 (395).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn60",
      "id": "ft60"
    }
  }, [_vm._v("60")]), _vm._v(". Tillich, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:396, 400.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn61",
      "id": "ft61"
    }
  }, [_vm._v("61")]), _vm._v(". So also Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:587.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn62",
      "id": "ft62"
    }
  }, [_vm._v("62")]), _vm._v(". For details, see Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:588–89.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn63",
      "id": "ft63"
    }
  }, [_vm._v("63")]), _vm._v(". Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:527.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn64",
      "id": "ft64"
    }
  }, [_vm._v("64")]), _vm._v(". For details and sources, see Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:527–30.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn65",
      "id": "ft65"
    }
  }, [_vm._v("65")]), _vm._v(". Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:546.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn66",
      "id": "ft66"
    }
  }, [_vm._v("66")]), _vm._v(". Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:547, emphasis in original.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn67",
      "id": "ft67"
    }
  }, [_vm._v("67")]), _vm._v(". See Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:546–50.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn68",
      "id": "ft68"
    }
  }, [_vm._v("68")]), _vm._v(". Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:551–52.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn69",
      "id": "ft69"
    }
  }, [_vm._v("69")]), _vm._v(". Tillich, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:418.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn70",
      "id": "ft70"
    }
  }, [_vm._v("70")]), _vm._v(". Moltmann, "), _c('em', [_vm._v("God in Creation")]), _vm._v(", p. xi.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn71",
      "id": "ft71"
    }
  }, [_vm._v("71")]), _vm._v(". T. Finger, "), _c('em', [_vm._v("A Contemporary Anabaptist Theology")]), _vm._v(", p. 563.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn72",
      "id": "ft72"
    }
  }, [_vm._v("72")]), _vm._v(". R. Russell, "), _c('em', [_vm._v("Cosmology")]), _vm._v(", p. 37.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn73",
      "id": "ft73"
    }
  }, [_vm._v("73")]), _vm._v(". R. Russell, "), _c('em', [_vm._v("Cosmology")]), _vm._v(", pp. 37–38.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn74",
      "id": "ft74"
    }
  }, [_vm._v("74")]), _vm._v(". Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:552.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn75",
      "id": "ft75"
    }
  }, [_vm._v("75")]), _vm._v(". R. Russell, “Cosmology and Eschatology,” in "), _c('em', [_vm._v("OHE")]), _vm._v(", p. 567.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn76",
      "id": "ft76"
    }
  }, [_vm._v("76")]), _vm._v(". Moltmann, "), _c('em', [_vm._v("Theology of Hope")]), _vm._v(", pp. 16–17. See also Rahner, “Hermeneutics of Eschatological Assertions,” p. 343; for comments, see P. Phan, “Roman Catholic Theology,” pp. 222–23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn77",
      "id": "ft77"
    }
  }, [_vm._v("77")]), _vm._v(". Moltmann, "), _c('em', [_vm._v("Theology of Hope")]), _vm._v(", pp. 19–22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn78",
      "id": "ft78"
    }
  }, [_vm._v("78")]), _vm._v(". McClendon, "), _c('em', [_vm._v("Doctrine")]), _vm._v(", pp. 75–77, 92; the latter quoted phrase is from Murphy, “The Resurrection Body and Personal Identity,” p. 205.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn79",
      "id": "ft79"
    }
  }, [_vm._v("79")]), _vm._v(". McClendon, "), _c('em', [_vm._v("Doctrine")]), _vm._v(", pp. 44, 75. For an insightful discussion of “the language of eschatology,” see also Pannenberg, "), _c('em', [_vm._v("ST")]), _vm._v(" 3:621–22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn80",
      "id": "ft80"
    }
  }, [_vm._v("80")]), _vm._v(". Gillman, "), _c('em', [_vm._v("The Death of Death")]), _vm._v(", p. 25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn81",
      "id": "ft81"
    }
  }, [_vm._v("81")]), _vm._v(". S. R. L. Clark, “Deep Time,” p. 193; I am indebted to Wilkinson, "), _c('em', [_vm._v("Christian Eschatology")]), _vm._v(", p. 25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn82",
      "id": "ft82"
    }
  }, [_vm._v("82")]), _vm._v(". Westhelle, “Liberation Theology,” pp. 312–13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn83",
      "id": "ft83"
    }
  }, [_vm._v("83")]), _vm._v(". Moltmann, "), _c('em', [_vm._v("God in Creation")]), _vm._v(", p. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn84",
      "id": "ft84"
    }
  }, [_vm._v("84")]), _vm._v(". Moltmann, "), _c('em', [_vm._v("God in Creation")]), _vm._v(", pp. 2–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn85",
      "id": "ft85"
    }
  }, [_vm._v("85")]), _vm._v(". For important comments, see Moltmann, "), _c('em', [_vm._v("God in Creation")]), _vm._v(", pp. 2–4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn86",
      "id": "ft86"
    }
  }, [_vm._v("86")]), _vm._v(". Schloss, “From Evolution to Eschatology,” p. 58.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn87",
      "id": "ft87"
    }
  }, [_vm._v("87")]), _vm._v(". McGrath, "), _c('em', [_vm._v("A Brief History of Heaven")]), _vm._v(", pp. 1–7 (1).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3329b2a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Chapter01.vue
// module id = 81
// module chunks = 0